import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterPagoPremio from 'views/cash/pagopremio/filterPagoPremio'; // Importing FilterPagoPremio component
import PagoPremio from 'views/cash/pagopremio/PagoPremio'; // Importing PagoPremio component
import TablePagoPremio from 'views/cash/pagopremio/tablePagoPremio'; // Importing TablePagoPremio component
import DetailsPagoPremio from 'views/cash/pagopremio/detailsPagoPremio'; // Importing DetailsPagoPremio component
import RecordPagoPremio from 'views/cash/pagopremio/recordPagoPremio'; // Importing RecordPagoPremio component
import { devConfig } from 'config/config'; // Importing devConfig for configuration settings

/**
 * Class representing the payment prize view.
 * @extends JetView
 */
export default class pagoPremioView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            // Right section configuration
            type: 'wide',
            rows: [PlayersView, DetailsPagoPremio, RecordPagoPremio], // Components in the right section
        };
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from configuration
                },
            ],
        };
        const left = {
            // Left section configuration
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        {
                            width: 30,
                            css: 'back-button', // Back button styling
                            view: 'button',
                            type: 'icon',
                            icon: 'wxi-angle-left', // Back icon
                            id: 'back-button',
                            align: 'center',
                            click: () => {
                                // Click event for back button
                                $$('FilterPagoPremio').show(); // Show filter
                                $$('FilterPagoPremio').clear(); // Clear filter
                                $$('FilterPagoPremio').clearValidation(); // Clear validation
                                $$('formPagoPremio').hide(); // Hide form
                                $$('tablePagoPremio').hide(); // Hide table
                                $$('toolbar').hide(); // Hide toolbar
                                $$('pagerA').hide(); // Hide pager
                                $$('back-button').hide(); // Hide back button
                            },
                        },
                        { view: 'label', label: _('Pago Premio') }, // Label for the title
                        {
                            type: 'wide',
                            css: 'close-bottom', // Close button styling
                            cols: [
                                {
                                    view: 'icon', // Close icon
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                FilterPagoPremio, // Filter component
                PagoPremio, // Payment prize component
                TablePagoPremio, // Table component for displaying data
                toolbar, // Toolbar component
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen
        return {
            // Return the main configuration object
            id: 'a5',
            type: 'clean',
            view: 'form', // Main view type
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left section
                },
            ],
        };
    }

    /**
     * Initializes the view.
     */
    init() {
        $$('back-button').hide(); // Hide the back button on initialization
    }
}

// FILE DOCUMENTED
